module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "box1"
  }, [_c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("LIFE IS SHORT, ETERNITY IS LONG")]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "h2a"
  }, [_vm._v("Kimberly")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Therefore we do not lose heart. Though outwardly we are wasting away, yet inwardly we are being renewed day by day. For our light and momentary troubles are achieving for us an eternal glory that far outweighs them all. So we fix our eyes not on what is seen, but on what is unseen, since what is seen is temporary, but what is unseen is eternal.")]), _vm._v(" "), _c('p', {
    staticClass: "centers"
  }, [_vm._v("2 CORINTHIANS 4:16–18")]), _vm._v(" "), _c('p', {
    staticClass: "normal3"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_c('span', {
    staticClass: "co"
  }, [_vm._v("W")])]), _vm._v("hen Abbey was very little, we moved out of state and started the search for a whole new medical team to treat her developmental delays. At the new pediatrician’s office, the doctor looked her over and worked with her muscles. When the words “cerebral palsy” came out of his mouth, I stood there with my own gaping wide open. I had to ask him to repeat himself. In a casual second to him, my world went from “delay” (with the hope of someday catching up) to a lifelong diagnosis of disability. I had to pull over on the way home to cry.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("I had lost the mother-daughter relationship and future I had dreamed about since the day they told me, “It’s a girl.” Predictions of the future, paired with memories of my own childhood as a little girl, flooded my heart with grief. As the extent of our daughter’s disabilities "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v("unfolded, I realized I would never hear the sound of a little girl humming and singing through the house. I would never watch her skip or play teatime with her dolls. All the moments that I longed for in this life would never happen the way I had hoped.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("At some point in the grief process, I realized I had put my hope in the wrong future, and that’s why it hurt so badly. It was why I could not heal and move on. The Lord began to whisper eternity over my soul with verses like 2 Corinthians 4:16–18. To accept Christ is to accept the gospel; to live in Christ is to live in the light of it. Because of what Christ has done for us on the cross, we hold on to the treasured promise that heaven makes all things right. Heaven restores things to the way they were meant to be. There are no diagnoses or disabilities in heaven.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Revelation 21:3–4 says about this new heaven,")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("I heard a loud voice from the throne saying, “Look! God’s dwelling place is now among the people, and he will dwell with them. They will be his people, and God himself will be with them and be their God. ‘He will wipe every tear from their eyes. There will be no more death’ or mourning or crying or pain, for the old order of things has passed away.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Psalm 119:49–50 exclaims, “Remember your word to your servant, in which you have made me hope. This is my comfort in my affliction, that your promise gives me life” ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESV")]), _vm._v("). God’s Word gives us hope. This is our comfort, and the promises contained in his Word give us life.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Years ago, my mom started speaking the phrase “Life is short, eternity is long” over me. When this refrain becomes part of our souls, it helps transfer our affections and gaze from this life on earth to eternity with Christ. James 4:14 reminds us, “Why, you do not even know what will happen tomorrow. What is your life? You are a mist that appears for a little while and then vanishes.” This moment we are in right now is not the end of the story. An eternal perspective gives great hope.")]), _vm._v(" "), _c('div', {
    staticClass: "top1"
  }, [_c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('i', [_vm._v("Father, help me to fix my eyes on you and not on my child’s diagnosis. Help me to trust you not only for this life but for eternity. Restore to me the joy of my salvation, and with it the great hope of heaven. In Jesus’s name, amen.")])])]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGGING")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EEPER")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("1."), _c('span', {
    staticClass: "space5"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("How have you handled your child’s diagnosis?")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("2."), _c('span', {
    staticClass: "space5"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("What hope and comfort do you find in the promises of heaven with Christ?")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("3."), _c('span', {
    staticClass: "space5"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("What can you do to foster this truth in your life?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8418ec00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Chapter01.vue
// module id = 84
// module chunks = 0